<template>
  <div class="single-article">
    <single-article :articleId="$route.params.id">
      <template slot-scope="props">
        <article class="article main-article" v-if="props.article">
          <header>
            <article-tags :tags="['lvn_topic_oid']" :article="props.article" :showTags="false" @onTagsLoaded="onTagsLoaded"></article-tags>
            <h1>{{ props.article.title }}</h1>
            <ul class="details">
              <li>{{ props.article.date }}</li>
              <li v-for="(tag, index) in tags">
                <router-link :to="{ name: 'ArticlesForCategory', params: { categoryValue: props.article.lvn_topic_oid } }">
                  {{ tag.name }}
                </router-link>
              </li>
            </ul>
          </header>
          <div class="main">
            <div v-html="props.article.body_html"></div>
          </div>
        </article>
        <div class="sharing">
          <div class="title"><i class="ion-android-share-alt"></i> Partage</div>
          <ul class="social">
            <li>
              <a href="https://www.facebook.com/sharer/sharer.php" class="facebook" target="_blank">
                <i class="ion-social-facebook"></i> Facebook
              </a>
            </li>
            <li>
              <a :href="`https://twitter.com/home?status=${pageUrl}`" class="twitter" target="_blank">
                <i class="ion-social-twitter"></i> Twitter
              </a>
            </li>
            <li>
              <a :href="`https://plus.google.com/share?url=${pageUrl}`" class="googleplus" target="_blank">
                <i class="ion-social-googleplus"></i> Google+
              </a>
            </li>
            <li>
              <a :href="`https://www.linkedin.com/shareArticle?mini=true&url=${pageUrl}`" class="linkedin" target="_blank">
                <i class="ion-social-linkedin"></i> Linkedin
              </a>
            </li>
          </ul>
        </div>
        <mail-transfer :id="$route.params.id" broadcastChannel="LaVieNumerique"/>
      </template>
    </single-article>
    <h4>Commentaires</h4>
    <comments :id="$route.params.id"></comments>
  </div>
</template>


<script>
  import { SingleArticle, ArticleTags, Comments, MailTransfer } from 'itrnews-vuejs-api';

  export default {
    name: 'ArticlePage',
    components: { SingleArticle, ArticleTags, Comments, MailTransfer },
    methods: {
      onTagsLoaded(tags) {
        this.tags = tags;
      },
    },
    mounted() {
      this.pageUrl = window.location.href;
    },
    data() {
      return {
        tags: [],
        pageUrl: '',
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ArticlePage.vue